export default {
  '3xs': {
    fontSize: 8,
    lineHeight: `${10}px`,
  },
  '2xs': {
    fontSize: 10,
    lineHeight: `${12}px`,
  },
  xs: {
    fontSize: 12,
    lineHeight: `${14}px`,
  },
  sm: {
    fontSize: 14,
    lineHeight: `${16}px`,
  },
  md: {
    fontSize: 16,
    lineHeight: `${18}px`,
  },
  lg: {
    fontSize: 18,
    lineHeight: `${22}px`,
  },
  xl: {
    fontSize: 20,
    lineHeight: `${24}px`,
  },
  '2xl': {
    fontSize: 24,
    lineHeight: `${26}px`,
  },
  '3xl': {
    fontSize: 28,
    lineHeight: `${30}px`,
  },
  '4xl': {
    fontSize: 36,
    lineHeight: `${38}px`,
  },
  '5xl': {
    fontSize: 48,
    lineHeight: `${50}px`,
  },
  '6xl': {
    fontSize: 64,
    lineHeight: `${66}px`,
  },
};
